import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type LegalDocument = 'privacy' | 'terms' | null;
const LEGAL_CONTENT = {
  privacy: {
    title: 'Privacy Policy',
    body: ['Esta política explica cómo se utiliza la información necesaria para procesar tu compra y entregar el eBook.', 'La información proporcionada se utiliza únicamente para completar tu pedido, habilitar el acceso al producto y mejorar la experiencia de compra. No se vende ni se alquila información personal.', 'Al continuar usando esta página o realizar una compra, aceptas esta política de privacidad.']
  },
  terms: {
    title: 'Terms of Use',
    body: ['El Mapa de los "Casi Algo" es un material digital de orientación y reflexión personal. No reemplaza atención médica, psicológica o terapéutica profesional.', 'Tu compra concede acceso personal al eBook. No está permitido reproducir, compartir, revender o distribuir el contenido sin autorización.', 'Al completar una compra, confirmas que utilizarás el contenido de forma personal y responsable.']
  }
};
export function Footer() {
  const [openDocument, setOpenDocument] = useState<LegalDocument>(null);
  const activeDocument = openDocument ? LEGAL_CONTENT[openDocument] : null;
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpenDocument(null);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
  return <>
      <footer className="w-full border-t border-white/10 bg-ink py-10" data-id="element-17">
        <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-18">
          <p className="font-display text-lg italic text-cream" data-id="element-19">
            El Mapa de los "Casi Algo"
          </p>
          <p className="mt-2 text-sm text-muted" data-id="element-20">
            Cierra el ciclo. Recupera tu centro. — © {new Date().getFullYear()}{' '}
            Todos los derechos reservados.
          </p>
          <nav aria-label="Legal" className="mt-5 flex justify-center gap-5 text-sm" data-id="element-21">
            <button type="button" onClick={() => setOpenDocument('privacy')} className="text-muted underline-offset-4 transition-colors hover:text-cream hover:underline focus:outline-none focus:ring-2 focus:ring-electric focus:ring-offset-2 focus:ring-offset-ink" data-id="element-22">
              Privacy
            </button>
            <button type="button" onClick={() => setOpenDocument('terms')} className="text-muted underline-offset-4 transition-colors hover:text-cream hover:underline focus:outline-none focus:ring-2 focus:ring-electric focus:ring-offset-2 focus:ring-offset-ink" data-id="element-23">
              Terms
            </button>
          </nav>
        </div>
      </footer>

      <AnimatePresence data-id="element-24">
        {activeDocument && <motion.div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onMouseDown={() => setOpenDocument(null)} data-id="element-25">
            <motion.section role="dialog" aria-modal="true" aria-labelledby="legal-document-title" className="relative w-full max-w-xl rounded-2xl border border-white/10 bg-midnight p-7 shadow-2xl sm:p-9" initial={{
          opacity: 0,
          y: 16,
          scale: 0.98
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 16,
          scale: 0.98
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} onMouseDown={event => event.stopPropagation()} data-id="element-26">
              <button type="button" onClick={() => setOpenDocument(null)} aria-label="Cerrar" className="absolute right-4 top-4 rounded-full p-2 text-muted transition-colors hover:bg-white/10 hover:text-cream focus:outline-none focus:ring-2 focus:ring-electric" data-id="element-27">
                <XIcon className="h-5 w-5" data-id="element-28" />
              </button>
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-rose-glow" data-id="element-29">
                Legal
              </p>
              <h2 id="legal-document-title" className="mt-3 pr-10 font-display text-3xl font-semibold text-cream" data-id="element-30">
                {activeDocument.title}
              </h2>
              <div className="mt-6 space-y-4 leading-relaxed text-muted" data-id="element-31">
                {activeDocument.body.map(paragraph => <p key={paragraph} data-id="element-32">{paragraph}</p>)}
              </div>
            </motion.section>
          </motion.div>}
      </AnimatePresence>
    </>;
}